/*
 Created by CHT 2020/5/16 15:57
 */

//-------获取验证码 start
export const USER_CODE_REG = 0  // 注册
export const USER_CODE_PASS = 1 // 忘记密码
export const USER_CODE_TEL = 2  // 修改手机
export const USER_CODE_LOGIN = 4  // 修改手机
//-------end

//------ 校验用户是否存在
export const USER_NOT_EXIST = 0  // 不存在
export const USER_EXIST_NOT_BIND_WECHAT = 1 //  存在 未绑定微信
export const USER_EXIST_BIND_WECHAT = 2  // 存在已绑定微信
//------

//------ excel导入数据上传状态
export const FILE_READING = 'FILE_READING' // 文件读取中
export const FILE_ANALYZE = 'FILE_ANALYZE' // 文件解析中
export const IMPORT_PREPARED = 'IMPORT_PREPARED' // 导入准备完成
export const IMPORTING = 'IMPORTING' // 导入中
export const IMPORT_COMPLETE = 'IMPORT_COMPLETE' // 导入完成
export const IMPORT_FAILED = 'IMPORT_FAILED' // 导入失败
//------

//------ 表单类型
export const FORM_TYPE_DIRECTORY = 0   // 表单目录
export const FORM_TYPE_FORM = 1        // 流程表单
export const FORM_TYPE_DASHBOARD = 2   // 仪表盘
export const FORM_TYPE_EVENT_FORM = 3  // 事件表单
export const FORM_TYPE_AGGREGATION = 4  // 聚合表单
export const FORM_TYPE_THIRD_PAGE = 6  // 第三方页面
//------

//----- 表单视图类型
export const FORM_VIEW_TYPE_WRITE_FORM = 'writeForm' // 填写表单
export const FORM_VIEW_TYPE_DATA_HANDLE = 'dataHandle' // 全部数据
export const FORM_VIEW_TYPE_TRACE = 'TRACE' // 数据追踪
export const FORM_VIEW_TYPE_DATA_VIEW = 'DATA_VIEW' // 数据视图
export const FORM_VIEW_TYPE_BOARD_VIEW = 'BOARD_VIEW' // 看板视图
export const FORM_VIEW_TYPE_MAP_PATH_VIEW = 'MAP_PATH_VIEW' // 地图轨迹视图
export const FORM_VIEW_TYPE_MAP_BUBBLE_VIEW = 'MAP_BUBBLE_VIEW' // 地图气泡视图
export const FORM_VIEW_TYPE_DASHBOARD_VIEW = 'DASHBOARD' // 地图气泡视图
export const FORM_VIEW_TYPE_GANTT = 'GANTT' // 甘特视图
export const FORM_VIEW_TYPE_PHOTO = 'GALLERY' // 甘特视图
export const FORM_VIEW_TYPE_BOARD_VIEW_V2 = 'BOARD_VIEW_V2' // 甘特视图
//------

//----- 优惠券状态
export const COUPON_STATUS_UN_START = 'UN_START' // 待生效
export const COUPON_STATUS_WAIT_GIVE = 'WAIT_GIVE' // 待领取
export const COUPON_STATUS_WAIT_USE = 'WAIT_USE' // 待使用
export const COUPON_STATUS_USED = 'USED' // 已使用
export const COUPON_STATUS_EXPIRE = 'EXPIRE' // 已过期
//------

//----- 优惠券类型
export const COUPON_TYPE_REBATE = 'REBATE' // 折扣券
export const COUPON_TYPE_VOUCHER = 'VOUCHER' // 抵扣券
export const COUPON_TYPE_CASH_BACK = 'CASH_BACK' // 返现券
export const COUPON_TYPE_RESOURCE_GIVE = 'RESOURCE_GIVE' // 权益兑换券
export const COUPON_TYPE_LEVEL_DELAY = 'LEVEL_DELAY' // 等级延期
//------

//------ 企业微信跳转类型
export const WECHAT_JUMP_TYPE_LOGIN = 'LOGIN' // 扫码登录
export const WECHAT_JUMP_TYPE_ADMIN_AUTH = 'ADMIN_AUTH' // 管理员授权
export const WECHAT_JUMP_TYPE_INSTALL = 'INSTALL' // 未登录安装
export const WECHAT_JUMP_TYPE_REGISTER = 'PROMOTE' // 注册

//------ 融合表挂载类型
export const MIX_FORM_ITEM_TYPE_NODE = 'NODE' // 下级目录
export const MIX_FORM_ITEM_TYPE_MIX_FORM = 'MIX_FORM' // 融合表
export const MIX_FORM_ITEM_TYPE_ATTACHMENT = 'ATTACHMENT' // 附件
export const MIX_FORM_ITEM_TYPE_IMAGE = 'IMAGE' // 图片附件
export const MIX_FORM_ITEM_TYPE_MEMO = 'MEMO' // 备忘录
export const MIX_FORM_ITEM_TYPE_DATA = 'DATA' // 表单数据
export const MIX_FORM_ITEM_TYPE_VIEW = 'VIEW' // 表单视图
export const MIX_FORM_ITEM_TYPE_TODO = 'TODO' // 待办视图
export const MIX_FORM_ITEM_TYPE_DASHBOARD = 'DASHBOARD' // 仪表盘
export const MIX_FORM_ITEM_TYPE_APPLY = 'APPLY' // 发起表单
